import {Component} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {TranslateService} from "app/translate/translate.service";
import {FilterFormService} from "app/views/filter_form/filter_form.service";
import {EventsService} from "app/lib/EventsService";
import {BaseComponent} from "app/views/base.component";
import {ChartParams} from "../../views/chart/chart.component";
import {Pagination} from "../../models/pagination.model";

import merge from 'lodash-es/merge';
import * as qs from 'qs';
import { BillingService2 } from "../billing.service";

@Component({
	selector: 'conversion_rate',
	templateUrl: './conversion_rate.component.html'
})
export class ConversionRateComponent extends BaseComponent {
	rows;

	chartPeriod = '30days';
	langTab = 'ru';

	reportUrl: string = this.router.url.split('?')[0];
	
	listLoader = false;

	firstChart = new ChartParams();
	secondChart = new ChartParams();

	showLabels = {
		firstChart: ['tariffVisitCount', 'paymentVisitCount', 'paidCount'],
		secondChart: ['tariffAndPaymentConversion', 'paidAndPaymentConversion']
	};

	totalPages = 0;
	currentPage = 1;
	pages = [];
	links = [];

	paginationLoader = true;

	constructor(
		public route: ActivatedRoute,
		public translate: TranslateService,
		public filter: FilterFormService,
		public eventsService: EventsService,
		private router: Router,
		public service2: BillingService2,
	) {
		super(eventsService, service2, route, filter, translate);

		this.route.queryParams.subscribe((params: any) => {
			this.langTab = params.langTab || 'ru';
		});
		
		this.firstChart.setOptions({
			title: '',
			names: {
				'paidCount': this.translate.__A('adminstat.yandex.paidCount'),
				'tariffVisitCount': this.translate.__A('adminstat.yandex.tariffVisitCount'),
				'paymentVisitCount': this.translate.__A('adminstat.yandex.paymentVisitCount')
			},
			colors: {
				'tariffVisitCount': '#ff7f0e',
				'paymentVisitCount': '#2ca02c',
				'paidCount': '#d62728'
			},
			showLabels: this.showLabels.firstChart
		});

		this.secondChart.setOptions({
			title: '',
			names: {
				'tariffAndPaymentConversion': this.translate.__A('adminstat.yandex.tariffAndPaymentConversion'),
				'paidAndPaymentConversion': this.translate.__A('adminstat.yandex.paidAndPaymentConversion')
			},
			colors: {
				'tariffAndPaymentConversion': '#ff7f0e',
				'paidAndPaymentConversion': '#2ca02c'
			},
			showLabels: this.showLabels.secondChart
		});
	}
	
	get localFilter() {
		return {
			langTab: this.langTab,
			page: this.filter.filterParams.page,
			chartPeriod: this.filter.filterParams.period == 'day' ? this.chartPeriod : 'all', 
			period: this.filter.filterParams.period, 
			chartFormat: 'c3angular'
		};
	}

	async getData() {
		await this.getChart();
		await this.getPagination();
		await this.getStats();
	}

	async getChart() {
		this.firstChart.showLoader();
		
		const { charts } = await this.service2.conversionRate.chart(
			this.localFilter
		).toPromise();
		
		let fdata = [];
		let sdata = [];

		for (let row of charts) {
			let id = row[0];
			if (id == 'x') {
				fdata.push(row);
				sdata.push(row);
			} else {
				if (this.showLabels.firstChart.includes(id.toString())) {
					fdata.push(row);
				}
				if (this.showLabels.secondChart.includes(id.toString())) {
					sdata.push(row);
				}
			}
		}

		this.firstChart.data = fdata;
		this.secondChart.data = sdata;

		this.firstChart.hideLoader();
	}

	async updateData(filter, type) {
		await this.getChart();
	}

	// Получить данные для пагинации
	async getPagination() {
		const me = this;
		
		me.totalPages = 1;
		me.currentPage = 1;
		me.pages = [];
		
		me.paginationLoader = true;
		
		const pagination = await me.service2.conversionRate.pagination(
			me.localFilter
		).toPromise();
		me.pagination.fill(pagination);
		
		if (pagination) {
			me.updateLinks(
				me.service2.conversionRate.getRealFullRoute()
			);
		}
		
		me.paginationLoader = false;
	}
	
	async getStats() {
		
		// TODO Тут старая конструкция, но отчет не факт что живой
		const { stats } = await this.service2.conversionRate.stats(
			{
				...this.localFilter,
				paginationDate: this.pages[this.filter.filterParams.page - 1],
			},
			
		).toPromise();
		
		this.stats = stats;
	}
	
	async onPageChange() {
		this.filter.filterParams.page = this.pagination.page;
		
		this.filter.filterParams.dateFilterParams = this.filter.getDateFilterParams(this.filter.filterParams, this.filter.addFilterParams);

		let params = this.filter.getApplyFilters(this.filter.filterParams),
			url = this.router.url.split('?')[0];

		params = qs.stringify(params, {encode: false});
		this.router.navigateByUrl(`${url}?${params}`, {relativeTo: this.activatedRoute});

	}
	
	async onFilterChange(chartPeriod) {
		this.chartPeriod = chartPeriod;

		await this.getChart();
	}
}
